<span class="loader" [class.loader_block]="!showInline()" [class.loader_small]="showSmall()">
  <span class="loader__wrapper">
    <span class="loader__figure"></span>
    @if (showText()) {
      <span> {{ message() | translate }}</span>
    }
  </span>
</span>
